import { useState } from 'react';
import { isDescendant } from '../helpers/isDescendant';

export const useFieldsetFocusEvents = (focusEvents: {
  onBlur?: (event: React.FocusEvent<HTMLDivElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLDivElement>) => void;
}): {
  onBlur: (event: React.FocusEvent<HTMLDivElement>) => void;
  onFocus: (event: React.FocusEvent<HTMLDivElement>) => void;
} => {
  const [inFocus, setInFocus] = useState(false);

  const onFocus = (event: React.FocusEvent<HTMLDivElement>): void => {
    /*  Call only if previously focussed element is not in input and newly focussed 
          element is in input.

          IE doesn't support relatedTarget, and we have no fallback to track the previously focused
          element, so we have to track the focus state ourselves.
      */
    if (!inFocus) {
      focusEvents.onFocus?.(event);
      setInFocus(true);
    }
  };

  const onBlur = (event: React.FocusEvent<HTMLDivElement>): void => {
    /*  Call only if previously focussed element is in input and newly focussed 
          element is not in input.

          IE doesn't support relatedTarget, so fallback to the document's active element
      */
    const newlyFocussedElement = (event.relatedTarget ??
      document.activeElement) as Node | null;
    // Ignore changing focus within this component
    if (inFocus && !isDescendant(event.currentTarget, newlyFocussedElement)) {
      focusEvents.onBlur?.(event);
      setInFocus(false);
    }
  };

  return { onBlur, onFocus };
};
